import {defineMessages} from 'react-intl';

import type {KeycloakLogOperationType} from './types';
import {type KeycloakLogEntityType, type KeycloakLogResourceType} from './types';

export const keycloakLogEntityType: KeycloakLogEntityType = 'KeycloakLog';

export const KeycloakLogServiceTypes = {
    service: Symbol.for('KeycloakLogService'),
} as const;

export const KeycloakLogTypeName = 'KeycloakLog';
export const KeycloakLogViewModelTypeName = 'KeycloakLogViewModel';
export const KeycloakLogViewModelKeysTypeName = 'KeycloakLogViewModelKeys';
export const KeycloakLogViewModelKeysArrayTypeName = 'KeycloakLogViewModelKeysArray';
export const KeycloakLogDataGridColumnTypeName = 'KeycloakLogDataGridColumn';
export const KeycloakLogQueryFieldsTypeName = 'KeycloakLogQueryFields';

export const resourceTypeLocalized = defineMessages<KeycloakLogResourceType>({
    USER: {
        id: 'KeycloakLogResourceType_USER',
        defaultMessage: 'User',
    },
    GROUP_MEMBERSHIP: {
        id: 'KeycloakLogResourceType_GROUP_MEMBERSHIP',
        defaultMessage: 'Group Membership',
    },
});

export const operationTypeLocalized = defineMessages<KeycloakLogOperationType>({
    ACTION: {
        id: 'KeycloakLogOperationType_ACTION',
        defaultMessage: 'Action',
    },
    CREATE: {
        id: 'KeycloakLogOperationType_CREATE',
        defaultMessage: 'Create',
    },
    UPDATE: {
        id: 'KeycloakLogOperationType_UPDATE',
        defaultMessage: 'Update',
    },
    DELETE: {
        id: 'KeycloakLogOperationType_DELETE',
        defaultMessage: 'Delete',
    },
});
